import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import DatabaseAnalyticsPlugin from './AnalyticsPlugin';
import DatabaseClipboardPlugin from './ClipboardPlugin';
import DatabaseDatePlugin from './DatePlugin';
import DatabaseDefaultPlugin from './DefaultPlugin';
import DatabaseModalPlugin from './ModalPlugin';
import DatabaseNotesPlugin from './NotesPlugin';
import DatabaseNumberPlugin from './NumberPlugin';
import DatabaseScrollPlugin from './ScrollPlugin';
import DatabaseSelectPlugin from './SelectPlugin';
import DatabaseTextPlugin from './TextPlugin';
import DatabaseTodoPlugin from './TodoPlugin';
import DatabaseTypingPlugin from './TypingPlugin';
import DatabaseUserPlugin from './UserPlugin';
import DatabaseUsersPlugin from './UsersPlugin';
export default function getPlugins(_ref) {
  var _ref$getUser = _ref.getUser,
      getUser = _ref$getUser === void 0 ? function () {
    return null;
  } : _ref$getUser,
      _ref$fetchNotes = _ref.fetchNotes,
      fetchNotes = _ref$fetchNotes === void 0 ? function () {
    return Promise.resolve([]);
  } : _ref$fetchNotes,
      _ref$fetchUsers = _ref.fetchUsers,
      fetchUsers = _ref$fetchUsers === void 0 ? function () {
    return Promise.resolve([]);
  } : _ref$fetchUsers,
      _ref$makeNoteLinkPlug = _ref.makeNoteLinkPlugin,
      makeNoteLinkPlugin = _ref$makeNoteLinkPlug === void 0 ? function (_ref2) {
    var _ref2$NoteLinkPlugin = _ref2.NoteLinkPlugin,
        NoteLinkPlugin = _ref2$NoteLinkPlugin === void 0 ? function (y) {
      return y;
    } : _ref2$NoteLinkPlugin,
        _ref2$trackingSource = _ref2.trackingSource,
        trackingSource = _ref2$trackingSource === void 0 ? 'database_notelink' : _ref2$trackingSource;
    return function (x) {
      return NoteLinkPlugin(x);
    };
  } : _ref$makeNoteLinkPlug,
      _ref$setActiveModal = _ref.setActiveModal,
      setActiveModal = _ref$setActiveModal === void 0 ? function (x) {
    return x;
  } : _ref$setActiveModal,
      track = _ref.track;
  return [].concat(_toConsumableArray(DatabaseTextPlugin()), _toConsumableArray(DatabaseDatePlugin()), _toConsumableArray(DatabaseUserPlugin({
    getUser: getUser
  })), _toConsumableArray(DatabaseTodoPlugin()), _toConsumableArray(DatabaseNumberPlugin()), _toConsumableArray(DatabaseSelectPlugin()), _toConsumableArray(DatabaseUsersPlugin({
    fetchUsers: fetchUsers
  })), _toConsumableArray(makeNoteLinkPlugin({
    NoteLinkPlugin: DatabaseNotesPlugin({
      fetchNotes: fetchNotes
    }),
    trackingSource: 'database_notelink'
  })({
    isPublic: false
  })), _toConsumableArray(DatabaseTypingPlugin()), _toConsumableArray(DatabaseClipboardPlugin()), _toConsumableArray(DatabaseModalPlugin({
    setActiveModal: setActiveModal
  })), _toConsumableArray(DatabaseScrollPlugin()), _toConsumableArray(DatabaseAnalyticsPlugin({
    track: track
  })), _toConsumableArray(DatabaseDefaultPlugin()));
}